import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

export default function () {
    const swiper = new Swiper('.testimonials-slider', {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: true,
        autoHeight: false,
        speed: 1500,
        grabCursor: true,
        loop: true,
        autoplay: {
            delay: 5000
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 31,
                initialSlide: 1
            }
        }
    });
}